import { ProcessGeneral } from 'api/endpoints/processes';
import { ProcessVersionGeneral } from 'api/endpoints/processVersions';

export type ProcessDraftOrRelease = ProcessGeneral | ProcessVersionGeneral;

function isGeneral(process: ProcessDraftOrRelease): process is ProcessGeneral {
  return 'state' in process;
}

/**
 * If process is a draft, return the draft ID. If process is a version, return the release ID.
 */
export function getReleaseOrDraftID(process: ProcessDraftOrRelease): string {
  if (isGeneral(process)) {
    return process.id;
  }

  return process.releaseId;
}
